export default {
    ApexChatBaseUrl: '',
    ApexChatDefaultLogLevel: 0,
    LiveChatServiceUrl: '',
    CompanyContextRequest: '',
    ApexChatBetaUrl: '',
    CdnBaseUrl: '',
    CompanyLevelBlockedPages: '',
    CompanyLevelSettings: '',
    TrackerNow: new Date().getTime(),
    Tracking: false,
    TmpleteCache: {},
    Styles: {},
    iframeStyles: {},
    preChatRoundedThemeName: 'Rounded Style',
    predefinedMessageId: -2,
    visitorEndSoundVolume: 35,
    videoChatStarted: false,
    runVideoChatInitOnlyOnce: false,
    videoChatDisconnected: false,
    tabIndexCount: 0, // for ADA Compliance use
    ADAElements: [], // for ADA Compliance use
    encodedHtmlRegex: /([^']*)\&(amp|quot|[gl]t),([^']*)/g,
    scriptTagRegex: /<script[\s\S]*?>[\s\S]*?<\/script>/gi,
    styleTagRegex: /<style[\s\S]*?>[\s\S]*?<\/style>/gi,
    regexWeekDay: /\b((Mon|Tues|Wed(nes)?|Thur(s)?|Fri|Sat(ur)?|Sun)(day)?)\b/g, // ref. https://www.regextester.com/94091
    regexTime: /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/g, // ref. https://www.regextester.com/104041
    regexOfficeHours:
        /(Mon|Tues|Wed(nes)?|Thur(s)?|Fri|Sat(ur)?|Sun)(day)?:\s+(((1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm])\s?-\s?(1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm]))|Closed)/g, // https://regexr.com/5c8a9
    encodedAnchorRegex: /<a[^>]title:("|').*?("|')/g,
    // JIRA_2666 - 28AUG17 - END
    // JIRA_3188 - 23JAN18 - START - Sound flooding prevention
    avoidSoundFlooding: 0,
    timeIntervalSoundFlood: null,
    // JIRA_3188 - END
    ChatCloseWarningMessage: 'This will end the chat, are you sure?',
    DOM_CHAT_TITLE: 'Opens a chat window', // chat title show on start chat button
    WINDOWED_CHAT_TITLE: 'Opens a new window for chat', // chat title show on start chat button
    DOM_CHAT_TITLE_SPA: 'Opens a chat window in Spanish', // chat title show on start chat button
    WINDOWED_CHAT_TITLE_SPA: 'Opens a new window for chat in Spanish', // chat title show on start chat button
    FULLTEXT_MULTIPLE_MESSAGE_DELIMITER: '||',
    PIPE_QUESTION_TYPE_DELAY_SECOND: 0.001,
    CHAT_ENDED_MESSAGE: 'The chat session has ended.',
    defaultTimeInterval: 15,
    alwaysTrackOnce: false,
    scriptId: 0
};
